import { render } from "./FileMultiUploadRedesigned.vue?vue&type=template&id=18d2b1ee&scoped=true"
import script from "./FileMultiUploadRedesigned.vue?vue&type=script&lang=js"
export * from "./FileMultiUploadRedesigned.vue?vue&type=script&lang=js"

import "./FileMultiUploadRedesigned.vue?vue&type=style&index=0&id=18d2b1ee&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d2b1ee"]])

export default __exports__